module.exports = __webpack_public_path__ + "img/Group125.84e134a5.png";